<template>
    <dash
        icon="fa fa-thumbs-down"
        titulo="ENTREGAS COM ERRO NO COMPROMETIMENTO"
        :qtd="qtd"
        :loading="loading"
        color="#ff4040"
    ></dash>
</template>

<script>
import Dash from '@/shared/components/DashComponent2'

export default {
    props: {
        qtd: {
            type: Number
        },

        loading: {
            type: Boolean
        }
    },

    components: {
        Dash
    },

    data() {
        return {}
    }
}
</script>
